var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmedInterview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 14.6667C11.6816 14.6667 14.6663 11.682 14.6663 8.00007C14.6663 4.31817 11.6816 1.3334 7.99967 1.3334C4.31778 1.3334 1.33301 4.31817 1.33301 8.00007C1.33301 11.682 4.31778 14.6667 7.99967 14.6667ZM11.0889 6.92266C11.4144 6.59722 11.4144 6.06959 11.0889 5.74415C10.7635 5.41871 10.2359 5.41871 9.91042 5.74415L7.16634 8.48823L6.08893 7.41082C5.76349 7.08538 5.23586 7.08538 4.91042 7.41082C4.58498 7.73625 4.58498 8.26389 4.91042 8.58933L6.57709 10.256C6.90252 10.5814 7.43016 10.5814 7.7556 10.256L11.0889 6.92266Z",
    fill: "#3A836C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmedInterview);
export default __webpack_public_path__ + "static/media/confirmed-interview.9df743e6c607e9b81da5427cbbb162f6.svg";
export { ForwardRef as ReactComponent };